module.exports = __webpack_public_path__ + "static/media/View-1.07937744.webp";